/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/thoughtful/spotify-context-switching-done-right.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/thoughtful/spotify-context-switching-done-right.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/spotify-context-switching-done-right.mdx';

const metadata = {
  slug: "spotify-context-switching-done-right",
  title: "Spotify: Context Switching Done Right",
  author: "Christian Battaglia",
  description: "How does Spotify maintain a seamless experience across desktop, mobile, web, smart speakers, and Chromecast? A deep dive into their C++ core, Cosmos interface layer, and the lessons it holds for every cross-platform product.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/2018-04-10_spotify-context/pankaj-patel-493242.webp",
  date: "2018-04-10T00:00:00.000Z",
  
  readTime: "7 min read",
  tags: ["Spotify","C++","architecture","cross-platform","Rust","CEF","Cosmos","music technology","mobile","desktop"],
};

export const Route = createFileRoute('/blog/posts/spotify-context-switching-done-right')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/spotify-context-switching-done-right',
    image: '/og/blog/spotify-context-switching-done-right.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
